import { Injectable } from "@angular/core";
import { ApiService } from "src/services/http/api.service";
import { BackendBody } from "../../shared/backend-api.types";
import { toPageQuery } from "../http/pagination.utils";

type AuditLogsPage = BackendBody["OrderAuditLogDataPage"];

type AuditLog = BackendBody["ApiOrderAuditLog"];

type OrderUpdateRequest = BackendBody["LogOrderUpdateRequest"];

type OrderCreationStepRequest = BackendBody["LogOrderCreationStepRequest"];

@Injectable({
  providedIn: "root",
})
export class OrderAuditLogService {
  constructor(private readonly apiService: ApiService) {}

  public async getAuditLogsByOrderId(orderId: string, first: number = 20, offset: number = 0): Promise<AuditLogsPage> {
    return this.apiService.sendGetRequest(`orders/${orderId}/audit_logs`, {
      ...toPageQuery({ first, offset }),
    });
  }

  public async getUserAuditLogs(userId: string, first: number = 20, offset: number = 0): Promise<AuditLogsPage> {
    return this.apiService.sendGetRequest(`users/${userId}/audit_logs`, {
      ...toPageQuery({ first, offset }),
    });
  }

  public async logOrderUpdate(
    orderId: string,
    changedFields: OrderUpdateRequest["changedFields"],
    metadata?: OrderUpdateRequest["metadata"],
  ): Promise<AuditLogsPage> {
    return this.apiService.sendPostRequest<OrderUpdateRequest, AuditLogsPage>(`orders/${orderId}/audit_logs`, {
      changedFields,
      metadata,
    });
  }

  public logOrderCreationStep(
    temporaryOrderId: string,
    stepName: string,
    fieldsSet: OrderCreationStepRequest["fieldsSet"],
    metadata?: OrderCreationStepRequest["metadata"],
  ): Promise<AuditLog> {
    return this.apiService.sendPostRequest<OrderCreationStepRequest, AuditLog>(`orders/audit_logs/creation_step`, {
      temporaryOrderId,
      stepName,
      fieldsSet,
      metadata,
    });
  }
}
